import { t } from '@lingui/core/macro';
import { Loader, Typography } from '@pocketlaw/tetris';
import { Container } from './styled';
export function SidebarLoader(props) {
    const { title, message, overlay = false } = props;
    const fallbackTitle = t({
        message: 'Loading...',
        comment: 'Message when the document sidebar is loading',
    });
    return (<Container $overlay={overlay}>
      <Loader size={24}/>
      <Typography $color="primary.900">{title || fallbackTitle}</Typography>
      {message && (<Typography $color="primary.800" $fontSize="small">
          {message}
        </Typography>)}
    </Container>);
}
